import { Injectable } from '@angular/core';
import { ReferenceDataOptionLists } from 'rome-library';

@Injectable({
  providedIn: 'root'
})
export class FaqContextStore {
  private readonly FaqCaseEndpoint = 'getFaqDataForCase';
  private readonly FaqContextEndpoint = 'getFaqDataForContext';

  public FaqEndpoint: string;
  public FaqContext: string;

  constructor() {
    this.resetContext();
  }

  setFaq(action: string, context: string): void {
    if (action === this.FaqCaseEndpoint && context) {
      this.FaqEndpoint = action;
      this.FaqContext = context;
    } else if (
      context === ReferenceDataOptionLists.CaseTypeCustomerMortgageAccountOption ||
      context === ReferenceDataOptionLists.CaseTypeAdvisedOption
    ) {
      this.FaqContext = context;
    }
  }

  resetContext(): void {
    this.FaqContext = ReferenceDataOptionLists.CaseTypeNonAdvisedOption;
    this.FaqEndpoint = this.FaqContextEndpoint;
  }

  setNewBusinessContext(caseId: string): void {
    this.FaqContext = caseId;
    this.FaqEndpoint = this.FaqCaseEndpoint;
  }

  setExistingBusinessContext(): void {
    this.FaqContext = ReferenceDataOptionLists.CaseTypeCustomerMortgageAccountOption;
    this.FaqEndpoint = this.FaqContextEndpoint;
  }

  setAdviceContext(): void {
    this.FaqContext = ReferenceDataOptionLists.CaseTypeAdvisedOption;
    this.FaqEndpoint = this.FaqContextEndpoint;
  }
}
